module.exports = __webpack_public_path__ + "img/slika55.76c6538c.jpg";